<template>
    <li class="tree-li" :data-row="row[itemKey]">
        <div :class="{bold: isFolder}" v-if="!item.hide">
            <div class="table-responsive ums-tree">
                <table class="table">
                    <tbody>
                        <tr class="cursor-pointer">
                            <td style="width: 5%" @click="toggle" >
                                <i :class="{' icon-arrow-down22':!isOpen,' icon-arrow-up22':isOpen}" class="btn" v-if="isFolder"/>
                                <i class="icon-arrow-right22 btn" v-else/>
                            </td>
                            <td style="width: 50%">
                                <div style="display: flex;" @click="selectItem">
                                    <div class="middle-div" :class="{'active':row[itemKey]===selectedItem[itemKey]}" >
                                        <span>{{row[itemTitle]}}</span>
                                    </div>
                                    <div class="ml-auto" @click="checkItem">
                                        <div class="checkbox">
                                            <label>
                                                <div class="uniform-checker border-success-600 text-success-800">
                                                    <span :class="{'checked':row.checked}">
                                                        <input type="checkbox" name="checkbox" class="control-success" :checked="row.checked">
                                                    </span>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <ul v-show="isOpen" v-if="isFolder">
            <basic-tree class="item"
                        v-for="(child, index) in item.children"
                        :item-key="itemKey"
                        :item-title="itemTitle"
                        :key="index"
                        :keys="keys"
                        :item="child"
                        :selected-item="selectedItem"
                        @emitItem="emitItem"/>
        </ul>
    </li>
</template>

<script>
    import BasicTree from "@/components/treeview/BasicTree"
    import validation from "@/config/mixin/validation";
    export default {
        name: "BasicTree",
        components: {BasicTree},
        props: {
            item: Object,
            selectedItem: Object,
            itemKey:String,
            itemTitle:String,
            keys:Array,
            canToggle: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                isOpen: true,
                row:{}
            }
        },
        mounted() {
            this.setRow(this.item)
        },
        computed: {
            isFolder: function () {
                return this.row.children &&
                    this.row.children.length
            }
        },
        methods: {
            toggle: function () {
                if (this.canToggle && this.isFolder) {
                    this.isOpen = !this.isOpen
                }
            },
            checkItem: function() {
                this.row.checked = !this.row.checked
            },
            selectItem: function() {
                this.$emit('emitItem',$.extend(true,{},this.row))
            },
            emitItem: function(item) {
                this.$emit('emitItem',item)
            },
            setRow: function(val) {
                this.row = $.extend(true,{},val)
                if(this.keys.indexOf(this.row[this.itemKey]) !== -1) {
                    this.row.checked = true
                }
            },
        },
        watch: {
            'item': function(val) {
                this.setRow(val)
            },
            'keys': function(val) {
                this.setRow(this.item)
            }
        }
    }
</script>

<style scoped>
    ul {
        list-style: none;
    }
    .table td {
        padding: 0.8rem  0.8rem  !important
    }
    tbody tr:hover {
        color: #00C73C;
        background-color: #F8F8F8;
    }
    .item {
        font-size:16px;
    }
    .ums-tree .opened {
        color: #00C73C;
        background-color: #F8F8F8;
    }
    .middle-div {
        display: inline-block;
        vertical-align: middle;
        padding: .4375rem .875rem;
    }
    .ums-tree .active {
        background-color: #00C73C;
        color: #fff;
    }
    .table td {
        padding: 0rem !important;
    }
</style>
